import { useEffect } from 'react';

import { Loader } from '@googlemaps/js-api-loader';

import { useWindowDimensions } from '../../hooks/WindowDimensions';
import {
  addMarkers,
  deduplicatedMarkers,
} from '../../provider/models/mapModel';
import styles from '../Pages/SingleInputPage/SingleInputPage.module.scss';

export default function Map({
  workshops,
  onZoomChange,
  mapZoom,
  mapCenter,
  onCenterChange,
  onMarkerClick,
  refreshMarkers,
}) {
  const [, windowWidth] = useWindowDimensions();
  const isDesktop = windowWidth > 450;

  const mapId = 'map';

  const loadMap = () => {
    const loader = new Loader({
      apiKey: 'AIzaSyCDjgQzWjJwOdPuAkmEtTN1Kkh80wt3RVE',
      version: 'weekly',
    });

    loader.load().then(() => {
      addMarkers({
        workshops: workshops,
        groupName: null, //unused
      });

      let mapZoomLocal = mapZoom;
      let mapPos = mapCenter;
      if (!mapPos && deduplicatedMarkers.length === 1) {
        mapPos = deduplicatedMarkers[0].googleObj.position;
        mapZoomLocal = 15;
      }

      let map = new window.google.maps.Map(document.getElementById(mapId), {
        center: mapPos,
        zoom: mapZoomLocal,
        disableDefaultUI: true,
        zoomControl: isDesktop,
      });
      let bounds = new window.google.maps.LatLngBounds();
      map.addListener('center_changed', () => onCenterChange(map));
      map.addListener('zoom_changed', () => onZoomChange(map));

      deduplicatedMarkers.forEach((marker) => {
        marker.googleObj.setMap(map);
        bounds.extend(marker.googleObj.position);

        marker.googleObj.addListener('click', () => {
          onMarkerClick(marker);
        });
      });

      // visibleCopy.forEach((marker) => {
      //   marker.googleObj.addListener("click", () => {
      //     onMarkerClick(marker);
      //   });
      // });

      // new MarkerClusterer(
      //   map,
      //   visibleCopy.map((item) => item.googleObj),
      //   {
      //     imageExtension: "svg",
      //     imageSizes: [38],
      //     imagePath: `${env.PUBLIC_URL}/assets/icons/map`,
      //     gridSize: 60,
      //     averageCenter: true,
      //     ignoreHidden: true,
      //   }
      // );

      if (!mapPos) {
        map.fitBounds(bounds, isDesktop ? 100 : 70);
      }

      refreshMarkers();

      const styles = {
        hide: [
          {
            featureType: 'poi.business',
            stylers: [{ visibility: 'off' }],
          },
        ],
      };

      map.setOptions({ styles: styles['hide'] });
    });
  };
  // TODO: refactor
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(loadMap, [workshops, isDesktop]);

  return <div id={mapId} className={styles.mapContainer}></div>;
}
